import React, {Component} from 'react';
import {Alert, Button, Card, Col, Form, FormGroup, Input, Row} from 'reactstrap';
import axios from 'axios';
import { connect } from 'react-redux';
import {Spinner} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

class Verify2FaPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            email: '',
            error: false,
            messageError: '',
            btnDisable: false,
            type2Fa: 0,
            pin: ''
        }
    }

    componentDidMount() {
        this.loadContent2Fa();
    }

    loadContent2Fa = () => {
        let dataAuth = {  
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(this.props.token);
        axios.get( process.env.REACT_APP_API_URL + '/api/loadContent2Fa',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        type2Fa: ref.data.type2Fa,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu đại lý thất bại',
                    loadPage: false,
                    name: '',
                })
            })
    }

    submitLogin = () => {
        this.setState({
            btnDisable: true,
            isLoading: true
        })
        let item = {
            'code': this.state.pin,
        };

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.post( process.env.REACT_APP_API_URL + '/api/check-confirm-2fa', item,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    // console.log(ref.data);
                    this.props.update2Fa({
                        is2Fa: true,
                    });
                } else {
                    this.setState({
                        error: true,
                        messageError: ref.data.message,
                        btnDisable: false
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Yêu cầu khôi phục mật khẩu cho tài khoản thất bại',
                    isLoading: false,
                    btnDisable: false
                })
            })
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <Row
                            style={{
                                height: '100vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Col md={6} lg={4} className="m-3">
                                <Card body>
                                    <Form onSubmit={() => this.submitLogin()}>
                                        <div className="text-center pb-3">
                                            <img
                                                src={ this.props.config.website_logo }
                                                className="rounded"
                                                style={{ width: 90, height: "auto", cursor: 'pointer' }}
                                                alt="logo"
                                            />
                                            <h4 className="text-primary mt-2">{ this.props.config.website_company ? this.props.config.website_company : '' }</h4>
                                            <div className="m-2 text-center">
                                                <h1 className="h4 color-dark mb-2">Xác thực 2 yếu tố (2FA)</h1>
                                                <p>
                                                    {
                                                        this.state.type2Fa === 2 ? (
                                                            <>Nhập mã pin từ Google Authenticator App để tiếp tục đăng nhập.</>
                                                        ) : (
                                                            <>Vui lòng kiểm tra email để lấy mã xác nhận và nhập vào ô bên dưới để xác thực phương thức xác thực.</>
                                                        )
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                        {
                                            this.state.error ? (

                                                <Alert color="danger">
                                                    <div className='text-center'>
                                                        { this.state.messageError }
                                                    </div>
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <FormGroup>
                                            <Input type="text" placeholder="Nhập mã xác thực" name="pin"
                                                   className="form-control" onChange={this.changeInput}
                                                   defaultValue={this.state.pin}
                                            />
                                        </FormGroup>
                                        <hr />
                                        <Button
                                            size="lg"
                                            className="bg-gradient-theme-left border-0"
                                            block
                                            onClick={() => this.submitLogin()}
                                        >
                                            Xác thực
                                        </Button>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        config: state.configSystem.config,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        update2Fa: (item) => {
            dispatch(({ type : 'update2Fa', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        logOut: () => {
            dispatch(({type : 'logOut'}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Verify2FaPage);